export type StageId = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface StageTheme {
  bg: string;
  eclipse: string;
  eclipseMid: string;
  eclipseGlow: string;
  accent: string;
}

export const STAGE_THEMES: Record<StageId, StageTheme> = {
  1: {
    bg: '#19224D',
    eclipse: '#364BAE',
    eclipseMid: '#364BAE52',
    eclipseGlow: '#364BAEb8',
    accent: '#6D85FF',
  },
  2: {
    bg: '#210D34',
    eclipse: '#52277B',
    eclipseMid: '#52277B52',
    eclipseGlow: '#52277Bb8',
    accent: '#7F3FBC',
  },
  3: {
    bg: '#3C0F2D',
    eclipse: '#75295C',
    eclipseMid: '#75295C52',
    eclipseGlow: '#75295Cb8',
    accent: '#C54E9E',
  },
  4: {
    bg: '#0D2320',
    eclipse: '#205A52',
    eclipseMid: '#205A5252',
    eclipseGlow: '#205A52b8',
    accent: '#25B19A',
  },
  5: {
    bg: '#092C39',
    eclipse: '#206078',
    eclipseMid: '#20607852',
    eclipseGlow: '#206078b8',
    accent: '#2FB0DF',
  },
  6: {
    bg: '#43174C',
    eclipse: '#772C86',
    eclipseMid: '#772C8652',
    eclipseGlow: '#772C86b8',
    accent: '#E562FF',
  },
  7: {
    bg: '#5B2D1A',
    eclipse: '#9C4A29',
    eclipseMid: '#9C4A2952',
    eclipseGlow: '#9C4A29b8',
    accent: '#FB804B',
  },
};

export function getStageTheme(stageNumber: number): StageTheme {
  const id: StageId =
    stageNumber >= 1 && stageNumber <= 7 ? (stageNumber as StageId) : 1;
  return STAGE_THEMES[id];
}
